import { createContentPropTypes } from '../../../helpers/content';

const content = {
	view: 'View',
	retry: 'Retry',
	search: 'Search',
	errorMessage: 'An error has occurred fetching payees. Please click button to retry.',
	noMatches: 'No payees found for the current search criteria',
	yourPayees: 'Your payees',
	yourAccounts: 'Your accounts',
	searchPayeesPlaceholder: 'Search payees',
	searchAccountsPlaceholder: 'Search accounts',
	searchUKPlaceholder: 'Search all UK payees',
	searchInternationalPlaceholder: 'Search all International payees',
	addPayeeButtonTitle: 'Add new payee',
	ukPayees: 'UK',
	internationalPayees: 'International',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
